<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <AcessoriesForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import AcessoriesForm from '@/components/settings/test-registers/acessories/AcessoriesForm'

export default {
  name: 'AcessoryAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    AcessoriesForm
  }
}
</script>
